module.exports = __webpack_public_path__ + "img/pdf-icon.76e69e0.png";